(() => {
  let bannerLoading;
  function loadBanner() {
    if (typeof window.privacyBanner?.showPreferences === 'function') return Promise.resolve();
    if (!bannerLoading) {
      bannerLoading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timeout = setTimeout(() => reject(new Error('Cookie preferences timed out.')), 10000);
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.onload = () => { clearTimeout(timeout); resolve(); };
        script.onerror = () => { clearTimeout(timeout); reject(new Error('Cookie preferences could not load.')); };
        document.head.append(script);
      }).catch(error => { bannerLoading = null; throw error; });
    }
    return bannerLoading;
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cookie-preferences]');
    if (!button || button.disabled) return;
    const status = button.parentElement.querySelector('[data-privacy-error]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.hidden = true;
    try {
      await loadBanner();
      await window.privacyBanner.showPreferences();
    } catch {
      status.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
